import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEmpresaSituacao } from '@/features/empresa/hooks/empresa-situacao/useEmpresaSituacao';
import { LayoutPrivado } from '@/features/layout/components/LayoutPrivado';
import { useLoadChatPro } from '@/features/layout/hooks/useLoadChatPro';
import { useEmpresaAtualSync } from '@/features/login/hooks/useEmpresaAtualSync';
import { resetLoginStore, useLoginStore } from '@/features/login/store';
import { userNeedToLogin } from '@/features/login/util/token';
import { apiPersonalizacaoInserir } from '@/features/personalizacao/api/apiPersonalizacaoInserir';
import { getIp, getPlatformInfo } from '@/std/platform';
import { attempt } from '@/std/result';
import { isLocalHost, isSandbox } from '@/std/url';

const ACESSO_ENVIADO_STORAGE_KEY = 'personalizacao-acesso-enviado';

function getEmpresasComAcessoEnviado(): number[] {
    const value = window.localStorage.getItem(ACESSO_ENVIADO_STORAGE_KEY);

    if (!value) {
        return [];
    }

    try {
        const empresas = JSON.parse(value);

        return Array.isArray(empresas)
            ? empresas.filter(
                  (empresaIdpk): empresaIdpk is number => typeof empresaIdpk === 'number',
              )
            : [];
    } catch {
        return [];
    }
}

async function registerPlatform(): Promise<void> {
    if (isLocalHost() || isSandbox()) {
        return;
    }

    const { empresaIdpk } = useLoginStore.getState();
    if (!empresaIdpk) {
        return;
    }

    const empresasComAcessoEnviado = getEmpresasComAcessoEnviado();
    if (empresasComAcessoEnviado.includes(empresaIdpk)) {
        return;
    }

    const platform = getPlatformInfo();
    const ip = await getIp();

    const info = {
        ip: ip.error ? null : ip.value,
        platform: JSON.stringify(platform),
    };

    const result = await attempt(
        apiPersonalizacaoInserir({
            per_referencia: 'FRONT_ACESSO',
            per_valor: info,
        }),
    );

    if (result.error) {
        console.error('Falha ao enviar informações de acesso', result.error);
        return;
    }

    window.localStorage.setItem(
        ACESSO_ENVIADO_STORAGE_KEY,
        JSON.stringify([...empresasComAcessoEnviado, empresaIdpk]),
    );
}

export const Route = createFileRoute('/a')({
    beforeLoad: async () => {
        if (await userNeedToLogin()) {
            const { login, empresaIdpk } = useLoginStore.getState();
            if (!login || empresaIdpk) {
                resetLoginStore();
            }
            throw redirect({ to: '/auth/login' });
        }

        void registerPlatform();
    },
    component: Component,
});

function Component() {
    useEmpresaAtualSync();
    const situacao = useEmpresaSituacao();
    useLoadChatPro();

    return (
        <>
            {situacao.Modal}
            <LayoutPrivado admin={false} topSlot={situacao.Header} />
        </>
    );
}
